import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Badge, Box, Button, Tooltip } from '@mui/material';
import { enqueueSnackbar } from 'notistack';

import { ItemType } from '../../../models/ItemType';
import { myLocalStorage } from '../../../myLocalStorage';
import { LoadingState, getItems, GetItemsResponse } from '../../../network/useNetwork';
import { AssignmentIcon } from '../../Icons'; 


export default function MyTaskView() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [loadingState, setLoadingState] = useState<LoadingState>(LoadingState.Ready);
  const [count, setCount] = useState<number>(0);

  const me = myLocalStorage.getItem('person');
  const company = myLocalStorage.getItem('company');

  useEffect(() => {
    if (loadingState === LoadingState.Ready) {
      setLoadingState(() => LoadingState.Loading);
      return;
    }

    if (loadingState === LoadingState.Loading) {
      getItems(ItemType.TaskCount, (response: GetItemsResponse) => {
        const { isSuccess, message, result } = response;

        if (!isSuccess || !result) {
          enqueueSnackbar(message ?? 'Error', { variant: 'error' });
          setLoadingState(() => LoadingState.Complete);
          return;
        }

        const { count } = result; 
        setCount(count ?? 0);
        setLoadingState(() => LoadingState.Complete);
      });
    }
  }, [loadingState]);

  const handleNav = () => {
    navigate('/administrator/tasks');
  };

  
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        mr: 1,
      }}
    >
      <Tooltip title='Tasks'>
        <Box component="span" sx={{ display: 'inline-flex' }}>
          <Button disabled={loadingState !== LoadingState.Complete} onClick={handleNav}>
            <Badge badgeContent={count} color='primary'>
              <AssignmentIcon sx={{ color: 'secondary.main' }} />
            </Badge>
          </Button>
        </Box>
      </Tooltip>
    </Box>
  );
}
